module.exports = __webpack_public_path__ + "2216abf4.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/about_snapshot.png
// module id = 1327
// module chunks = 13